import { createContext } from 'react'
import { AppContext } from '../types/app-context'

export const appContext = createContext<AppContext | null>(null)
